<template>
  <!-- 法律条例类目页 -->
  <div id="tiaoliify">

    <section class="w10f8"><taoliifycont /></section>
    <section><tiaoifyartic /></section>
    <section><tiaoifyartic /></section>
    <section><tiaoifyartic /></section>

  </div>
</template>

<script>

import taoliifycont from "./child/taoliifycont";
import tiaoifyartic from "./child/tiaoifyartic"; //文章列表

export default {
  name: "tiaoliify",
  components: {

    // 私
    taoliifycont,
    tiaoifyartic,
    
  },
};
</script>

<style lang="scss" scoped>
#tiaoliify {
    background-color: #fff;
  .w10f8{
    width: 100%;
  background-color: #f8f8f8;
  }
}
</style>